module.exports = __webpack_public_path__ + "files/c976ac8cc0a39f18960dc8a1d095f19c.png";